import script from "./NoticeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeTable.vue?vue&type=script&setup=true&lang=js"

import "./NoticeTable.vue?vue&type=style&index=0&id=23fdc28a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23fdc28a"]])

export default __exports__